import { makeStyles } from "@material-ui/core"

const styles = makeStyles((theme) => ({
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
    marginRight: theme.spacing(0.5),
  },
  dialogMinHeight: {
    minHeight: "220px",
    [theme.breakpoints.down("xs")]: {
      minHeight: "255px",
    },
  },
  inputBackgroundColor: {
    backgroundColor: "#F4F4F4",
  },
  buttonRoot: {
    height: "40px",
  },
  formHelperText: {
    marginLeft: "0px",
  },
}))

export default styles
